import { Component, forwardRef, Input } from '@angular/core';
import { ControlContainer, ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR, NgForm } from '@angular/forms';
import { SelektionskriterienDetailEntryMeta } from 'app/core/batch-auftrag-api';
import { keysToTranslate } from 'i18n/keys-to-translate';
import { AuftragGrundstueckIdentifikatorenSelectionComponent } from '../auftrag-grundstueck-identifikatoren-selection/auftrag-grundstueck-identifikatoren-selection.component';
import { MetaDisablerDirective } from '../../../../../shared/directives/meta-disabler.directive';
import { MetaValidatorDirective } from '../../../../../shared/directives/meta-validator.directive';
import { AuftragGemeindeSelectionComponent } from '../auftrag-gemeinde-selection/auftrag-gemeinde-selection.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'cap-auftrag-export-selection',
  templateUrl: './auftrag-export-selection.component.html',
  styleUrls: ['./auftrag-export-selection.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AuftragExportSelectionComponent),
      multi: true
    }
  ],
  viewProviders: [
    {
      provide: ControlContainer,
      useExisting: NgForm
    }
  ],
  imports: [
    AuftragGrundstueckIdentifikatorenSelectionComponent,
    FormsModule,
    MetaDisablerDirective,
    MetaValidatorDirective,
    AuftragGemeindeSelectionComponent,
    TranslatePipe
  ]
})
export class AuftragExportSelectionComponent implements ControlValueAccessor {
  @Input()
  heading = 'ZuExportierendeGrundstuecke';

  @Input()
  readonly: boolean;

  model: SelektionskriterienDetailEntryMeta;
  selection: string;

  propagateChange: (id: string) => void;
  propagateTouch: (_) => void;

  constructor() {
    keysToTranslate(['ZuExportierendeGrundstuecke']);
  }

  writeValue(obj: any): void {
    this.model = obj;
  }

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.propagateTouch = fn;
  }
}
